import { useState, useCallback } from "react";
import { getSubGenres } from "../utils/genres";

export const useGenreSelection = ({
  initialMainGenre = null,
  initialSubGenre = null,
  onMainGenreChange,
  onSubGenreChange,
  form,
} = {}) => {
  const [selectedMainGenre, setSelectedMainGenre] = useState(initialMainGenre);
  const [availableSubGenres, setAvailableSubGenres] = useState(
    initialMainGenre ? getSubGenres(initialMainGenre) : []
  );

  const handleMainGenreChange = useCallback(
    (value) => {
      setSelectedMainGenre(value);
      const subGenres = getSubGenres(value);
      setAvailableSubGenres(subGenres);

      if (form) {
        form.setFieldsValue({ subGenre: undefined });
      }

      if (onMainGenreChange) {
        onMainGenreChange(value, subGenres);
      }
    },
    [form, onMainGenreChange]
  );

  const handleSubGenreChange = useCallback(
    (value) => {
      if (onSubGenreChange) {
        onSubGenreChange(value);
      }
    },
    [onSubGenreChange]
  );

  return {
    selectedMainGenre,
    availableSubGenres,
    handleMainGenreChange,
    handleSubGenreChange,
    setSelectedMainGenre,
    setAvailableSubGenres,
  };
};
